import React, { useState } from 'react';
import { SOCIAS } from '../../data/constants';
import './Socias.css';

const SociaCard: React.FC<{ s: typeof SOCIAS[0] }> = ({ s }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="socia-card">
      <div className="socia-photo-area">
        {s.photo ? (
          <img className="socia-photo" src={s.photo} alt={s.name} loading="lazy" />
        ) : (
          <div className="socia-initials">{s.initials}</div>
        )}
      </div>
      <div className="socia-body">
        <h3 className="socia-name">{s.name}</h3>
        <span className="socia-title-tag">{s.titleTag}</span>
        <p className="socia-bio socia-summary">{s.summary}</p>
        {expanded && (
          <p className="socia-bio">
            {s.bio.split('\n\n').map((p, i) => (
              <React.Fragment key={i}>
                {i > 0 && <><br /><br /></>}
                {p}
              </React.Fragment>
            ))}
          </p>
        )}
        <button className="btn-mostrar-mas" onClick={() => setExpanded(!expanded)}>
          {expanded ? 'Mostrar menos ↑' : 'Mostrar más ↓'}
        </button>
        <div className="socia-tags">
          {s.tags.map((t) => <span className="tag" key={t}>{t}</span>)}
        </div>
      </div>
    </div>
  );
};

const Socias: React.FC = () => (
  <section id="socias">
    <div className="section-label">El Estudio</div>
    <h2 className="section-title">Conozca a nuestro<br /><em>equipo</em></h2>
    <div className="divider" />
    <div className="socias-grid">
      {SOCIAS.map((s) => <SociaCard key={s.initials} s={s} />)}
    </div>
  </section>
);

export default Socias;
